<template>
  <div style="width: 100%;height: 40px;line-height:40px; background-color: #1e9fff; color: #FFF;font-size: 16px;letter-spacing: 2px;overflow: hidden">
    <lay-row>
      <lay-col xs="12" sm="12" md="12">
        <div class="top-bar-bg">
          {{title}}
        </div>
      </lay-col>
      <lay-col xs="12" sm="12" md="12">
        <div style="text-align: right">
          <lay-button prefix-icon="layui-icon-ok-circle"  type="normal" style="padding: 0 5px;" v-if="false">清闪消音</lay-button>
          <BarClock v-if="false"/>
          <lay-button prefix-icon="layui-icon-user"  type="normal" style="padding: 0 3px 0 0;" @click="logout">用户注销</lay-button>
         </div>
      </lay-col>
    </lay-row>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
import {layer} from "@layui/layui-vue";
import BarClock from "@/components/BarClock";
const props = defineProps(['title', 'logouted'])

let layerId = null;

const logout = () => {
  layerId = layer.confirm("退出登录?",
      {title: "", move: false, closeBtn: false,
        btn: [{text:'确认', callback: ()=> {
          layer.close(layerId);
            props.logouted();
            window.location.hash = "#/111"; //登录页面
        }},{text:'取消', callback: ()=>{ layer.close(layerId) }}]})

}


</script>

<style scoped>
.top-bar-bg{
  background: #1e9fff url('../assets/logo.png') no-repeat 5px center;
  text-indent: 35px;
}
.user-avatar{
  background: url("../assets/user.png") no-repeat 20px center;
  text-indent: 50px;
  text-align: right;
  display: inline-block;
  margin-right: 15px;
  cursor: pointer;
}
</style>